import React, { useState } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { Container, Header, Heading, Content } from "../Summarize/Style";
import { Iframe } from "../Iframe/Style";
import BackIcon from "../../assets/back-icon.svg";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export default function Forest() {
  const user_id = localStorage.getItem("id");
  const email = localStorage.getItem("email");
  const isForestOnboarded = localStorage.getItem("isForestOnboarded");
  const [iframeSrc, setIframeSrc] = useState(`https://forest.aivoria.nl/?user_id=${user_id}&email=${email}&isForestOnboarded=${isForestOnboarded}`);
  const { isSidebarOpen } = useOutletContext();
  const navigate = useNavigate();
  return (
    <Container isOpen={isSidebarOpen} style={{ marginRight: "1.4rem" }}>
      <Header style={{ alignItems: "center", justifyContent: "space-between" }}>
        <div
          style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          <img src={BackIcon} alt="back" />

          <Heading style={{ marginBottom: 0 }}>
            Forest App
          </Heading>

          <Tooltip
            title="Bekijk informatie en beheer instellingen van Forest App"
            placement="top"
          >
            <InfoCircleOutlined
              style={{
                fontSize: 14,
                color: "#8c8c8c",
                cursor: "pointer",
              }}
              onClick={(e) => e.stopPropagation()} // prevent navigation
            />
          </Tooltip>
        </div>
      </Header>

      <Content>
        <Iframe src={iframeSrc} />
      </Content>
    </Container>
  );
}